import { render, staticRenderFns } from "./InputNumber.vue?vue&type=template&id=a5fb807e&scoped=true"
import script from "./InputNumber.vue?vue&type=script&lang=ts"
export * from "./InputNumber.vue?vue&type=script&lang=ts"
import style0 from "./InputNumber.vue?vue&type=style&index=0&id=a5fb807e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5fb807e",
  null
  
)

export default component.exports